import { i18n, locale } from "@src/utils/i18n";
import * as nls from "./nls";

const I18N = i18n(nls);
const openAddress = /localhost/.test(window.location.hostname) ? location.origin : "";
let navMenuData = [
  {
    id: "devbench-app-dev",
    curPage: null,
    pageSize: null,
    menuName: I18N["appDev"],
    resCode: "app-dev",
    resUrl: "#/1/wecode-v2",
    isHref: "0",
    resBelong: "public",
    resType: "1",
    parentResId: "0",
    domain: 9,
    parentResName: null,
    sortNo: 0,
    image: null,
    description: "test",
    tenantId: null,
    isAdminView: 0,
    menuUrl: "#/1/wecode-v2",
    subResList: null,
    isShowMenu: 1
  },
  {
    id: "devbench-app-connect",
    curPage: null,
    pageSize: null,
    menuName: I18N["appConnect"],
    resCode: "app-dev",
    resUrl: "#/wecode/myconnectors",
    isHref: "0",
    resBelong: "public",
    resType: "1",
    parentResId: "0",
    domain: 9,
    parentResName: null,
    sortNo: 0,
    image: null,
    description: "test",
    tenantId: null,
    isAdminView: 0,
    menuUrl: "#/wecode/myconnectors",
    subResList: null,
    isShowMenu: 1
  },
  {
    id: "developer-tools",
    curPage: null,
    pageSize: null,
    menuName: I18N["developTools"],
    resCode: "app-dev",
    resUrl: `${openAddress}/docs/#/990hh0/whokyc/vwd3yr`,
    resType: "1",
    resBelong: "public",
    parentResId: "0",
    isHref: "2",
    parentResName: null,
    sortNo: 0,
    image: null,
    description: "test",
    domain: 9,
    tenantId: null,
    isAdminView: 0,
    menuUrl: `${openAddress}/docs/#/990hh0/whokyc/vwd3yr`,
    subResList: null,
    isShowMenu: 1,
    children: []
  }
];

export const rightMenuData = [
  {
    id: "devDoc",
    menuName: I18N["devDocs"],
    resUrl: `${openAddress}/docs/#/990hh0/whokyc/vwd3yr`,
    menuUrl: `${openAddress}/docs/#/990hh0/whokyc/vwd3yr`,
    isHref: "2"
  }
];
export default navMenuData;
